export default __webpack_public_path__ + "static/media/paulasChoiceBha.ec4249f4.png";